import React from 'react'
import Loader from './components/Common/Loader'
import { Navigate } from "react-router-dom";
import TrademarkSearch from './components/Trademark/TrademarkSearch';

const ContactUs = React.lazy(() => import("./components/Contact/ContactUs"))
const PPC = React.lazy(()=>import( "./components/PPC/PPC"))
const Website = React.lazy(()=>import( "./components/Website/Website"))
const Thankyou = React.lazy(()=>import( "./components/Common/Thankyou"))
const Branding = React.lazy(()=>import( "./components/Branding/Branding"))
const WhatWeDoSection = React.lazy(()=>import( "./components/WhatWeDO/WhatWeDoSection"))
const WebsiteMantenanceServices = React.lazy(()=>import( "./components/Website-maintenance/WMS"))
const Home = React.lazy(()=>import( "./components/Home/Home"))
const Error = React.lazy(()=>import( "./components/Common/error"))
const Mobileuiuxdesign = React.lazy(()=>import( "./components/UI/UX/Mobileuiuxdesign"))
const Ecommerce = React.lazy(()=>import( "./components/Ecommerce/Ecommerce"))
const SEO = React.lazy(()=>import( "./components/SEO/SEO"))
const SMO = React.lazy(()=>import( "./components/SMO/Smo"))
const DigitalMarket = React.lazy(()=>import( "./components/Digital market/DigitalMarket"))
const SEOPackage = React.lazy(()=>import( "./components/Packages/SEO-package"))
const WebsiteDesignPackages = React.lazy(()=>import( "./components/Packages/WebsiteDesignPackages"))
const SMMPackage = React.lazy(()=>import( "./components/Packages/SMM-package"))
const Portfolio = React.lazy(()=>import( "./components/Portfolio/Portfolio"))
const DedicatedHosting = React.lazy(()=>import( "./components/Hosting/DedicatedHosting"))
const WebDevelopment = React.lazy(()=>import( "./components/Webdevelopment/WebDevelopment"))
const PPCPackage = React.lazy(()=>import( "./components/Packages/PPC-package"))
const SMOPackage = React.lazy(()=>import( "./components/Packages/SMO-package"))
const BrandPackage = React.lazy(()=>import( "./components/Packages/BrandPackage"))
const HireDedicatedManpower = React.lazy(()=>import( "./components/HireDedicatedManpower/HireDedicatedManpower"))
const DigitalMarketingPackages = React.lazy(()=>import( "./components/Packages/DigitalMarketingPackages"))
const WebsiteDevelopment = React.lazy(()=>import( "./components/Website Development/WebsiteDevelopment"))

const AppRoutes = [
    {
        index: true,
        element: <Home />,
        path: '/'
    },
    {
        index: true,
        element: <WhatWeDoSection />,
        path: '/who-we-are'
    },
    {
        index: true,
        element: <Error />,
        path: '*'
    },
    {
        index: true,
        element: <Website />,
        path: '/website-designing'
    },
    {
        index: true,
        element: <Navigate to="/website-designing" />,
        path: '/website'
    },
    {
        index: true,
        element: <Mobileuiuxdesign />,
        path: '/mobile-ui-ux-design'
    },
    {
        index: true,
        element: <Navigate to="/mobile-ui-ux-design" />,
        path: '/Web/mobileuiuxdesign'
    }
    ,
    {
        index: true,
        element: <SEO />,
        path: '/seo-company-in-india'
    },
    {
        index: true,
        element: <Navigate to="/seo-company-in-india" />,
        path: '/seo-company-in-delhi'
    },
    {
        index: true,
        element: <Ecommerce />,
        path: '/ecommerce-webdesign-in-india'
    },
    {
        index: true,
        element: <Navigate to="/ecommerce-webdesign-in-india" />,
        path: '/ecommerce-webdesign-in-delhi'
    },
    {
        index: true,
        element: <ContactUs />,
        path: '/contact-us'
    },
    {
        index: true,
        element: <SMO />,
        path: '/social-media-optimization-in-india'
    },
    {
        index: true,
        element: <Navigate to="/social-media-optimization-in-india" />,
        path: '/social-media-optimization-in-delhi'
    },
    {
        index: true,
        element: <DigitalMarket />,
        path: '/digital-marketing-services-in-india'
    },
    {
        index: true,
        element: <Navigate to="/digital-marketing-services-in-india" />,
        path: '/digital-marketing'
    },
    {
        index: true,
        element: <SEOPackage />,
        path: '/seo-packages'
    },
    {
        index: true,
        element: <Navigate to="/seo-packages" />,
        path: '/seopackages'
    },
    {
        index: true,
        element: <Branding />,
        path: '/branding'
    },
    {
        index: true,
        element: <WebsiteDesignPackages />,
        path: '/website-design-package'
    },
    {
        index: true,
        element: <SMMPackage />,
        path: '/smm-packages'
    },
    {
        index: true,
        element: <Navigate to="/smm-packages" />,
        path: '/smmpackages'
    },
    {
        index: true,
        element: <WebsiteMantenanceServices />,
        path: '/website-maintenance-services-in-india'
    },
    {
        index: true,
        element: <Navigate to="/website-maintenance-services-in-india" />,
        path: '/website-maintenance-services'
    },
    {
        index: true,
        element: <Portfolio />,
        path: '/portfolio'
    },
    {
        index: true,
        element: <DedicatedHosting />,
        path: '/dedicated-hosting'
    },
    {
        index: true,
        element: <WebDevelopment />,
        path: '/web-application-development'
    },
    {
        index: true,
        element: <PPCPackage />,
        path: '/ppc-packages'
    },
    {
        index: true,
        element: <Navigate to="/ppc-packages" />,
        path: '/PpcPackages'
    },
    {
        index: true,
        element: <SMOPackage />,
        path: '/smo-packages'
    },
    {
        index: true,
        element: <Navigate to="/smo-packages" />,
        path: '/Web/SmoPackages'
    },
    {
        index: true,
        element: <BrandPackage />,
        path: '/brand-packages'
    },
    {
        index: true,
        element: <HireDedicatedManpower />,
        path: '/hire-dedicated-manpower'
    },
    {
        index: true,
        element: <DigitalMarketingPackages />,
        path: '/digital-marketing-packages'
    },
    {
        index: true,
        element: <Navigate to="/digital-marketing-services-in-india" />,
        path: '/Web/onlinemarketing'
    },
    {
        index: true,
        element: <PPC />,
        path: '/ppc-services'
    },
    {
        index: true,
        element: <WebsiteDevelopment />,
        path: '/website-development-company-in-india'
    },
    {
        index: true,
        element: <Thankyou />,
        path: '/thankyou'
    },
    {
        index: true,
        element: <TrademarkSearch />,
        path: '/free-trademark-search-startups'
    }
]

export default AppRoutes;
